import React, { createContext, useContext } from 'react';

const VersionContext = createContext();

export const VersionProvider = ({ version, children }) => {
  return (
    <VersionContext.Provider value={version}>
      {children}
    </VersionContext.Provider>
  );
};

export const useVersion = () => useContext(VersionContext);
